<template>
    <el-drawer
        title="编辑员工"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="员工姓名">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="手机电话">
                    <el-input v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="登录密码">
                    <div class="fx">
                        <el-popconfirm @onConfirm="resetPwd()"
                                       title="确认重置该用户密码吗？"
                        >
                            <el-button slot="reference" type="primary" size="small" style="margin-right: 20px">重置密码</el-button>
                        </el-popconfirm>

                        <span class="text_info tr">*密码将重置为123456</span>
                    </div>

                </el-form-item>
                <el-form-item label="单点登录Token" v-if="showSSO">
                    <el-input v-model="form.ssoToken" ></el-input>

                </el-form-item>
                <el-form-item label="使用期限">
                    <div class="fx-col">
                        <el-date-picker
                            format="yyyy-MM-dd HH:mm:ss"
                            v-model="form.expireTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="date"
                            placeholder="选择使用期限">
                        </el-date-picker>
                    </div>

                </el-form-item>
                <el-form-item label="角色">
                    <el-checkbox-group v-model="form.roles">
                        <el-checkbox v-for="item in roles" :label="item.id+''" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>


        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .edit_form {
        margin-top: 20px;
        width: 88%;
    }
</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                form: {...this.item, roles: this.item.roles ? this.item.roles.split(",") : []},
                roles: [],
                showSSO: false,
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                if (this.form.ssoToken && this.form.ssoToken.length <8) {
                    this.$showError("单点登录Token长度不能小于8");
                    return false;
                }
                let data = {...this.form, roles: this.form.roles.join(",")};
                console.debug(data);
                this.$ajaxPost("/user/save", {
                    user: data
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                return false;
            },
            loadRoles() {
                this.$ajaxPost("/role/list", {
                    form: {
                        enable: true
                    }
                }, (data) => {
                    this.roles = data.result;
                })
            },
            resetPwd() {
                this.$ajaxGet("/user/resetPassword/"+this.item.id, (data) => {
                    this.$showSuccess("重置成功");
                })
            }

        },
        mounted() {
            this.show = true;
            this.showSSO = window.location.host.startsWith(process.env.VUE_APP_SSO_HOST+".");
        },
        created() {
            this.loadRoles();
        }


    }
</script>
